import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-tab-content" }

import { watch, inject, ref, onBeforeMount } from 'vue';
  import { IState as TabsState } from './index.vue';

  export interface IProps {
    label: string;
    href?: string;
  }
  
  // https://github.com/vuejs/rfcs/blob/master/active-rfcs/0040-script-setup.md#declaring-additional-options
  const __default__ = {
    name: 'AppTab'
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: null,
    href: null
  },
  setup(__props: any) {

  

  const index = ref(0);
  const isActive = ref(false);
  const tabs = inject<TabsState>('TabsProvider');

  if (tabs) {
      watch(
      () => tabs.selectedIndex,
      () => {
        isActive.value = index.value === tabs.selectedIndex;
      }
    );

    onBeforeMount(() => {
      index.value = tabs.count;
      tabs.count++;
      isActive.value = index.value === tabs.selectedIndex;
    });
  }


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ], 512)), [
    [_vShow, isActive.value]
  ])
}
}

})